import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Box, Typography } from "@mui/material";

const Loader = ({ finishLoading }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          clearInterval(timer);
          setTimeout(finishLoading, 500);
          return 100;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 150);

    return () => clearInterval(timer);
  }, [finishLoading]);

  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, y: -100 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#0A192F",
        zIndex: 10000,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: 800,
            background: "linear-gradient(135deg, #00E5FF 0%, #7C4DFF 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: 10,
            mb: 4,
          }}
        >
          SARTHAK
        </Typography>
      </motion.div>
      <Box sx={{ width: "200px", height: "2px", backgroundColor: "rgba(255,255,255,0.1)", position: "relative" }}>
        <motion.div
          style={{
            height: "100%",
            backgroundColor: "#00E5FF",
            position: "absolute",
            left: 0,
            top: 0,
          }}
          animate={{ width: `${progress}%` }}
        />
      </Box>
      <Typography variant="caption" sx={{ mt: 2, color: "text.secondary", letterSpacing: 2 }}>
        {Math.round(progress)}%
      </Typography>
    </motion.div>
  );
};

export default Loader;
